import { waLink, CENTRAL_URL } from "@/lib/site";

const LINKS = [
  { href: "#planos", label: "Planos" },
  { href: "#cobertura", label: "Cobertura" },
  { href: "#diferenciais", label: "Diferenciais" },
  { href: "#suporte", label: "Suporte" },
  { href: "#faq", label: "FAQ" },
  { href: CENTRAL_URL, label: "Central do Assinante", external: true },
];

export default function Navbar() {
  return (
    <header className="fixed inset-x-0 top-0 z-40 border-b border-white/5 bg-black/60 backdrop-blur-md">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 sm:px-8">
        <a href="#" data-testid="navbar-logo" aria-label="HPNET — voltar ao topo">
          <img
            src="/logo.png"
            alt="HPNET"
            className="h-12 invert brightness-110 contrast-150 mix-blend-screen sm:h-14"
          />
        </a>
        <nav className="hidden items-center gap-7 md:flex lg:gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              target={l.external ? "_blank" : undefined}
              rel={l.external ? "noopener noreferrer" : undefined}
              className="whitespace-nowrap text-sm text-white/60 transition-colors duration-200 hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          data-testid="navbar-cta"
          href={waLink("Olá! Quero assinar um plano da HPNET.")}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-md bg-violet-600 px-4 py-2.5 text-sm font-medium text-white shadow-[0_0_24px_rgba(124,58,237,0.35)] transition-colors duration-200 hover:bg-violet-500"
        >
          Contratar
        </a>
      </div>
    </header>
  );
}
